export default function useData() {
  const [ data, dispatch ] = React.useState<any>()

  return {
    ...data,
    dispatch: (name: string, value: any) => dispatch({ ...data, [name]: value }),
  }
}
